import { useFilesForCompanyId } from "src/api/hooks/useFiles";
import { FileType } from "src/types/InspectionUpdateRequest";
import useChangeTitle from "src/api/hooks/useChangeTitle";
import { lang } from "src/language/Strings";
import { DataCard } from "src/components/DataCard";
import { routes } from "src/routes";
import { useNavigate, useParams } from "react-router-dom";

export function ActiveSchemas() {
  const { data: files } = useFilesForCompanyId();
  useChangeTitle(lang.vehicleInspection);
  const navigate = useNavigate();
  const { companyId } = useParams();
  return (
    <div className="flex flex-col h-full w-full">
      <div>
        {files
          ?.filter(
            (f) => f.fileType === FileType.Schema && f.schemaId !== undefined
          )
          .map((file) => (
            <DataCard
              key={file.id}
              id={file.id?.toString() ?? ""}
              onClick={() => {
                navigate(
                  routes.VehicleInspection.Form.url(
                    companyId,
                    file.id?.toString() ?? ""
                  )
                );
              }}
              isSelected={false}
              header={file.comment}
              firstRowInput={file.fileName}
              secondRowInput={""}
              thirdRowInput={<></>}
            />
          ))}
      </div>
    </div>
  );
}
